export const reportPhishing = "Syc";
export default {reportPhishing};